<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import AddReturn from "./add.vue";
import EditItems from "./edit_items.vue";
import Items from "./items.vue";
import { GravyPath } from "../../../../../../path";
import moment from "moment";
import Swal from "sweetalert2";
export default {
  components: {
    Layout,
    PageHeader,
    add: AddReturn,
    edit_items: EditItems,
    items: Items,
  },
  data() {
    return {
      orders: [],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
      currentPage: 1,
      filter: [],
      fields: [
        "restaurant",
        "warehouse",
        "location",
        "date_of_return",
        "type_of_return",
        "return_to_inventory",
        "items",
        "invoice",
        "actions",
      ],
      fields2: [
        "warehouse",
        "location",
        "date_of_return",
        "type_of_return",
        "return_to_inventory",
        "items",
        "actions",
      ],
      items: [],
      title: "Order Returns",
      search: "",
      selectedOrder: null,
      type: "warehouse",
      status: "pending",
    };
  },
  watch: {
    currentPage() {
      this.getReturns();
    },
    status() {
      this.getReturns();
    },
    type() {
      this.getReturns();
    },
    search() {
      this.getReturns();
    },
  },
  methods: {
    addReturn() {
      this.selectedOrder = null;
      this.$bvModal.show("add-return");
    },
    async getReturns() {
      try {
        let res = await axios.get(
          this.base_url + GravyPath.ORDERS.GET_RETURNS,
          {
            params: {
              search: this.search,
              page: this.currentPage,
              status: this.status,
              type: this.type,
            },
          }
        );
        if (res.data.status) {
          this.orders = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    formatedDate(v) {
      return moment(v).format("YYYY-MM-DD");
    },
    editOrder(v) {
      this.selectedOrder = v;
      this.$bvModal.show("add-return");
    },
    editPending(v) {
      this.selectedOrder = v;
      this.$bvModal.show("edit-items");
    },
    viewItems(v) {
      this.selectedOrder = v;
      this.$bvModal.show("view-items");
    },
    async generateInvoice(v) {
      try {
        let res = await axios.get(
          this.base_url + GravyPath.ORDERS.GRAVY_ORDER_RETURN_INVOICE,
          {
            params: {
              id: v.id,
            },
          }
        );
        if (res.data.status) {
          this.downloadInvoiceFile(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    },
    downloadInvoiceFile(file) {
      const link = document.createElement("a");
      link.href = this.cdn + "/" + file;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async moveToAccepted(v) {
      try {
        let res = await axios.post(
          this.base_url + GravyPath.ORDERS.GRAVY_RETURN_MARK_ACCEPTED
        );
        if (res.data.status) {
          console.log(v);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async moveToCompleted(v) {
      try {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons
          .fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Mark As Completed",
            cancelButtonText: "No, cancel!",
            reverseButtons: true,
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              let res = await axios.post(
                this.base_url + GravyPath.ORDERS.GRAVY_RETURN_MARK_COMPLETE,
                {
                  id: v.id,
                }
              );
              if (res.data.status) {
                swalWithBootstrapButtons.fire({
                  title: "Updated!",
                  text: "Your Order has been updated.",
                  icon: "success",
                });
                this.getReturns();
              } else {
                swalWithBootstrapButtons.fire({
                  title: "Failed to Update!",
                  text: "Your Order has not beed updated",
                  icon: "error",
                });
              }
            } else if (
              /* Read more about handling dismissals below */
              result.dismiss === Swal.DismissReason.cancel
            ) {
              swalWithBootstrapButtons.fire({
                title: "Cancelled",
                text: "Status Not Updated :)",
                icon: "error",
              });
            }
          });
        this.getReturns();
      } catch (e) {
        console.log(e);
      }
    },
    async trashOrder(v) {
      try {
        let res = await axios.post(
          this.base_url + GravyPath.ORDERS.DELETE_RETURNS,
          {
            id: v.id,
          }
        );
        if (res.data.status) {
          Swal.fire("Updated Successfully", "", "success");
          this.getReturns();
        }
      } catch (e) {
        console.log(e);
      }
    },
    reload() {
      this.getReturns();
    },
  },
  mounted() {
    this.getReturns();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-header>
        <b-button variant="primary" @click="addReturn">Add Return</b-button>
      </b-card-header>
      <div class="col-sm-12 col-md-12 mt-2">
        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              v-model="search"
              type="search"
              debounce="100"
              class="form-control form-control-sm ml-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <b-tabs
        fill
        pills
        class="m-3"
        style="border-bottom: 1px solid gray; padding: 2px"
      >
        <b-tab title="Warehouse Returns" @click="type = 'warehouse'"></b-tab>
        <b-tab title="Restaurant Returns" @click="type = 'restaurant'"></b-tab>
      </b-tabs>
      <b-tabs>
        <b-tab title="Pending" @click="status = 'pending'"></b-tab>
        <b-tab title="Accepted" @click="status = 'accepted'"></b-tab>
        <b-tab title="Completed" @click="status = 'completed'"></b-tab>
      </b-tabs>
      <b-modal id="add-return" size="xl" hide-footer>
        <add :mainOrder="selectedOrder" @reload="reload"></add>
      </b-modal>
      <b-modal id="edit-items" size="xl" hide-footer>
        <edit_items
          :mainOrder="selectedOrder"
          :items_data="selectedOrder?.items"
          @reload="reload"
        ></edit_items>
      </b-modal>
      <b-modal id="view-items" size="xl" hide-footer>
        <items :items_data="selectedOrder?.items" :status="status"></items>
      </b-modal>
      <div class="table-responsive mb-0">
        <b-table
          :key="orders.key"
          :items="orders.data"
          :fields="type == 'warehouse' ? fields2 : fields"
          responsive="sm"
          :filter="filter"
          :current-page="currentPage"
        >
          <template v-slot:cell(restaurant)="row">
            <p>{{ row.item.restaurant?.name }}</p>
          </template>
          <template v-slot:cell(warehouse)="row">
            <p>{{ row.item.warehouse.name }}</p>
          </template>
          <template v-slot:cell(location)="row">
            <p>{{ row.item.location.location }}</p>
          </template>
          <template v-slot:cell(items)="row">
            <b-button variant="primary" @click="viewItems(row.item)"
              ><i class="fa fa-list"></i
            ></b-button>
          </template>
          <template v-slot:cell(date_of_return)="row">
            <p>{{ formatedDate(row.item.date_of_return) }}</p>
          </template>
          <template v-slot:cell(invoice)="row">
            <b-button
              @click="generateInvoice(row.item)"
              v-if="status != 'pending'"
              ><i class="fa fa-download">{{ row.item?.invoice }}</i></b-button
            >
          </template>
          <template v-slot:cell(return_to_inventory)="row">
            <p>{{ row.item.should_return_to_inventory == 1 ? "Yes" : "No" }}</p>
          </template>
          <template v-slot:cell(actions)="row">
            <b-button
              variant="success"
              class="mr-4"
              @click="editPending(row.item)"
              v-if="row.item.status == 'pending'"
              >Move To Accepted</b-button
            >
            <b-button
              variant="success"
              class="mr-4"
              @click="moveToCompleted(row.item)"
              v-if="row.item.status == 'accepted'"
              >Move To Completed</b-button
            >
            <b-button
              @click="editOrder(row.item)"
              v-if="row.item.status == 'pending'"
              class="mr-4"
              variant="primary"
              ><i class="fa fa-pen"></i
            ></b-button>
            <b-button
              @click="trashOrder(row.item)"
              v-if="row.item.status == 'pending'"
              variant="danger"
              ><i class="fa fa-trash"></i
            ></b-button>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                :key="orders.key"
                v-model="currentPage"
                :total-rows="orders.total"
                :per-page="orders.per_page"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card>
  </Layout>
</template>

<style></style>
